import type { ReductionEvidenceModel } from "@/api/cle-api";
import { UserQueryContext } from "@/context/UserContext";
import { formatLessons } from "@/util/number";
import { useContext } from "react";

import { DetailItem } from "../person/id/Efteruddannelse/DetailItem";
import { ExpandableText } from "../person/id/Efteruddannelse/ExpandableText";
import { ReductionEditModal } from "./ReductionEditModal";

interface ReductionInformationProps {
  reduction: ReductionEvidenceModel;
  onReductionUpdated?: (updated: ReductionEvidenceModel) => void;
}

export const ReductionInformation = ({
  reduction,
  onReductionUpdated,
}: ReductionInformationProps) => {
  const { user, hasPermission } = useContext(UserQueryContext);
  // Reported (indberettet) evidence backs a signed declaration and is immutable;
  // the API refuses these edits with 409 EVIDENCE_ALREADY_REPORTED.
  const canEdit = hasPermission(user, "TilsynWrite") && !reduction.isReported;

  const handleSave = (updated: ReductionEvidenceModel) => {
    onReductionUpdated?.(updated);
  };

  return (
    <div className="c-card c-item-list ">
      <div className="flex-100 d-flex justify-content-between flex-row align-items-center">
        <h3 className="mb-0">Reduktionsoplysninger</h3>
        {canEdit && (
          <ReductionEditModal reduction={reduction} onSave={handleSave} />
        )}
      </div>
      <div className="d-flex flex-column gap-2">
        <DetailItem
          label="Antal lektioner"
          value={formatLessons(reduction.numberOfLessons)}
        />
        <DetailItem
          label="Begrundelse"
          value={
            <ExpandableText
              id="reduction-reason-toggle"
              text={reduction.reason}
            />
          }
        />
      </div>
    </div>
  );
};
